import React, { useState } from 'react';

// 评级分级说明（基于 DefiSea LitePaper 的 5 级评分标准）
const GRADE_LEGEND = {
  'AAA': {
    range: '90-100',
    category: 'Gold Standard',
    description: 'Battle-tested, formally verified, fully decentralized. Suitable for large allocation; base asset.',
    recommendedAction: 'Suitable for large allocation; base asset'
  },
  'AA-A': {
    range: '75-89',
    category: 'Excellent',
    description: 'High security, minor centralization or liquidity nuances. Investment grade; quarterly monitoring.',
    recommendedAction: 'Investment grade; quarterly monitoring'
  },
  'BBB-B': {
    range: '60-74',
    category: 'Investment Grade',
    description: 'Manageable risk, due diligence required; limit exposure to anon team or newer model.',
    recommendedAction: 'Due diligence required; limit exposure'
  },
  'CCC': {
    range: '40-59',
    category: 'Speculative',
    description: 'Visible flaws (central keys, high inflation). High risk; small speculative positions only.',
    recommendedAction: 'High risk; small speculative positions only'
  },
  'D': {
    range: '<40',
    category: 'Junk/Critical',
    description: 'No audit, copy-paste code, active exploit risk. Avoid; high probability of principal loss.',
    recommendedAction: 'Avoid; high probability of principal loss'
  }
};

function GradeLegend({ grade, compact = false }) {
  const [isOpen, setIsOpen] = useState(false);
  
  if (!grade || grade === 'N/A') return null;
  
  const legend = GRADE_LEGEND[grade];
  if (!legend) return null;
  
  if (compact) {
    return (
      <div className="relative inline-flex items-end">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-5 h-5 rounded-full bg-yellow-400 hover:bg-yellow-500 text-white text-xs font-semibold flex items-center justify-center transition-colors leading-none mb-1"
          title="Rating explanation"
          aria-label="Show rating explanation"
        >
          ?
        </button>
        {isOpen && (
          <>
            {/* 遮罩层，点击关闭 */}
            <div 
              className="fixed inset-0 z-40" 
              onClick={() => setIsOpen(false)}
            />
            {/* 弹出框 */}
            <div className="absolute left-0 top-6 z-50 w-80 rounded-lg bg-white border border-gray-200 shadow-xl p-4 text-left">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="font-semibold text-gray-900 text-base">{grade}</div>
                  <div className="text-xs text-gray-500 mt-1">{legend.range} points</div>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-gray-400 hover:text-gray-600 text-sm"
                >
                  ✕
                </button>
              </div>
              <div className="text-xs text-gray-600 mb-2 font-medium">{legend.category}</div>
              <div className="text-xs text-gray-600 mb-2">{legend.description}</div>
              {legend.recommendedAction && (
                <div className="text-xs text-blue-600 font-medium mt-2 pt-2 border-t border-gray-200">
                  Recommended Action: {legend.recommendedAction}
                </div>
              )}
              
              <div className="pt-3 border-t border-gray-200">
                <div className="text-xs font-semibold text-gray-700 mb-2">Full Rating Scale:</div>
                <div className="space-y-1 text-xs text-gray-600 max-h-64 overflow-y-auto">
                  {Object.entries(GRADE_LEGEND).map(([g, info]) => (
                    <div key={g} className={`py-1 px-1 rounded ${g === grade ? 'bg-blue-50' : ''}`}>
                      <div className="flex items-start gap-2 mb-0.5">
                        <span className="font-semibold w-12 flex-shrink-0 text-gray-900">{g}</span>
                        <span className="text-gray-600 w-20 flex-shrink-0">{info.range}</span>
                      </div>
                      <div className="text-gray-600 ml-14">{info.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
  
  return (
    <div className="mt-4 rounded-lg bg-blue-50 border border-blue-100 p-4">
      <div className="flex items-start justify-between mb-2">
        <h4 className="text-sm font-semibold text-gray-900">Rating: {grade}</h4>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-gray-400 hover:text-gray-600 text-sm"
        >
          {isOpen ? '−' : '+'}
        </button>
      </div>
      <div className="text-xs text-gray-600 mb-1">
        <span className="font-medium">{legend.category}</span> • Score Range: {legend.range}
      </div>
      <div className="text-xs text-gray-600 mb-2">{legend.description}</div>
      {legend.recommendedAction && (
        <div className="text-xs text-blue-600 font-medium">
          Recommended Action: {legend.recommendedAction}
        </div>
      )}
      
      {isOpen && (
        <div className="mt-4 pt-4 border-t border-blue-200">
          <div className="text-xs font-semibold text-gray-700 mb-2">Full Rating Scale:</div>
          <div className="space-y-1 text-xs text-gray-600 max-h-64 overflow-y-auto">
            {Object.entries(GRADE_LEGEND).map(([g, info]) => (
              <div key={g} className={`py-1 ${g === grade ? 'bg-blue-100 -mx-2 px-2 rounded' : ''}`}>
                <div className="flex items-start gap-2 mb-0.5">
                  <span className="font-semibold w-12 flex-shrink-0 text-gray-900">{g}</span>
                  <span className="text-gray-600 w-20 flex-shrink-0">{info.range}</span>
                </div>
                <div className="text-gray-600 ml-14">{info.description}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default GradeLegend;

